module.exports = __webpack_public_path__ + "img/aPay.fb73e911.svg";